import { Alert } from '@ordo/ui/alert'
import { FlaskConical } from 'lucide-react'

import type { DryRunServiceType } from '@/lib/chefs/types'
import { dryRunServiceTypeLabel } from '@/lib/chefs/types'

/**
 * Warning on a campus card whose every shipment is a chef DRY RUN or TASTING
 * — not live service.
 *
 * These orders sit inline with real ones on purpose: the whole point is that
 * the chef rehearses on the surfaces they will actually use. That makes the
 * label load-bearing rather than decorative — without it a test cook is
 * indistinguishable from a real order. The two types diverge on DELIVERY:
 * a dry run is staged but never delivered (the evaluation happens at the
 * kitchen), while a tasting IS delivered to the prospect like real service.
 */
export function DryRunBanner({ className, serviceType }: { className?: string; serviceType?: DryRunServiceType }) {
  const label = dryRunServiceTypeLabel(serviceType)
  return (
    <Alert variant="warning" className={className}>
      <div className="flex items-start gap-3">
        <FlaskConical className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={2} />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="font-medium">{label} — not live service</div>
          <div className="opacity-80">
            {serviceType === 'TASTING'
              ? 'A tasting or sampling of meals. Prepare, stage, and deliver these meals as you would for real service.'
              : 'A test cook for your Ordo evaluation. Prepare and stage these meals as you would for real service, but do not deliver them.'}
          </div>
        </div>
      </div>
    </Alert>
  )
}
